/* eslint-disable import/no-default-export */
import Chance from 'chance';

const chance = new Chance();

export default () => ({
  progress: chance.floating({ min: 0, max: 1 }),
  score: chance.floating({ min: 0, max: 5 }),
  tips: [
    {
      action: {
        card: 'personal-details',
        field: 'current-location',
        mode: null,
        item: null,
      },
      label: 'Add home location',
      description: 'Help SEEK recommend more opportunities near you.',
      score: 1,
    },
    {
      action: {
        card: 'career-history',
        field: null,
        mode: null,
        item: null,
      },
      label: 'Add most recent role',
      description: 'Highlight your experience to employers.',
      score: 0.9,
    },
    {
      action: {
        card: 'next-role',
        field: 'classification',
        mode: null,
        item: null,
      },
      label: 'Add classification',
      description: 'Receive valuable industry insights from SEEK.',
      score: 0.8,
    },
    {
      action: {
        card: 'profile-visibility',
        field: 'level',
        mode: null,
        item: null,
      },
      label: 'Set profile visibility',
      description: 'Be found by potential employers.',
      score: 0.7,
    },
    {
      action: {
        card: 'education',
        field: null,
        mode: null,
        item: null,
      },
      label: 'Add education',
      description:
        'Show employers that you’re qualified and ready for their role.',
      score: 0.6,
    },
    {
      action: {
        card: 'resume',
        field: null,
        mode: null,
        item: null,
      },
      label: 'Add default resume',
      description:
        'You’re 50% more likely to be contacted by employers if you add a default resume.',
      score: 0.5,
    },
    {
      action: {
        card: 'skills',
        field: 'skills',
        mode: null,
        item: null,
      },
      label: 'Add 5 or more skills',
      description:
        'Employers search for skills on SEEK, don’t miss out on being found.',
      score: 0.4,
    },
    {
      action: {
        card: 'next-role',
        field: 'salary',
        mode: null,
        item: null,
      },
      label: 'Add a salary',
      description:
        'Add a minimum salary to appear in more searches by employers.',
      score: 0.2,
    },
    {
      action: {
        card: 'next-role',
        field: 'work-types',
        mode: null,
        item: null,
      },
      label: 'Add preferences',
      description: 'Add your preferences so jobs can come to you.',
      score: 0.1,
    },
  ],
});
